import axioPath from '../../../api/axioPath';
// import axios from 'axios';
import { UPDATE_DATA, UPDATE_LOCATIONS_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';


export const guestUserInventroy = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/search/get_inventory', data, {
      // headers: {
      //   Authorization: `${token}`,
      // },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const getNetworkByType = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/network/getNetworkByType', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postLoad = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const getLocationDetails = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('user/v2/get_sublocations_details', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_LOCATIONS_DATA, payload: response.data?.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const getCommunityGroupsApi = (token, id) => (dispatch) => {
  return axioPath
    .post(`rfp/v2/post/get_comm_memb_details/${id}`, {}, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const getSubLocationsByUser = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('user/location/getSubLocationsByUser', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const postLoadRepost = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postLoad/repost/' + `${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const postLoadRepostPopup = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  // .post('/rfp/postLoad/repost', data, {
  return axioPath.post('/rfp/v2/need/repost', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const placeBidPostLoad = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/bid/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const placeBid = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/place_bid', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const gradeList = (token, commodityName, moistureContent, isNew, isUsed, isCombo, isCores) => (dispatch) => {
  dispatch(showAppLoader());
  if (isNew === undefined && isUsed === undefined && isCombo === undefined) {
    isNew = true;
    isUsed = false;
    isCombo = false;
    isCores = false;
  }
  if (isNew === "New") {
    isNew = true;
  }
  let commodityNameVal = '';
  if (commodityName) {
    commodityNameVal = commodityName
  }
  return axioPath
    .get('/rfp/grade/get?commodityName=' + commodityNameVal + '&moistureContent=' + `${moistureContent}` + '&isNew=' + `${isNew}` + '&isUsed=' + `${isUsed}` + '&isCombo=' + `${isCombo}` + '&isCores=' + `${isCores}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const pinwheel = (token, commodityName, gradeName, newUsed, pinwheel) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/grade/quantity?commodityName=' + commodityName + '&gradeName=' + gradeName + '&newUsed=' + newUsed + '&pinwheelStandard=' + pinwheel, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postLoadById = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postLoad/bid/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerAddresses = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/buyer/addresses', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const buyerPrepopulate = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/buyerPostLoadProfile/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postLoadDropDownSearch = (params, pageNo, sortOrder, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/search/postLoad/search/nearby?' + params + '&page=' + `${pageNo}` + '&size=12&sort=' + `${sortOrder}` + '&fieldNameSort=created', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const searchNearbyNeed = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/search/nearby_need', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const postLoadAdvanceSearch = (params, pageNo, sortOrder, token, searchType) => (dispatch) => {
  dispatch(showAppLoader());
  if (!sortOrder)
    sortOrder = ""

  let url = '/search/postLoad/search?' + params + '&page=' + `${pageNo}` + '&size=12&sort=' + `${sortOrder}` + '&fieldNameSort=created'
  if (searchType === 'advanceSearch') url = '/search/postLoad/adv/search?' + params + '&page=' + `${pageNo}` + '&size=12&sort=' + `${sortOrder}` + '&fieldNameSort=created'
  return axioPath
    .get(url, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postLoadSearch = (title, pageNo, sortOrder, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postLoad/search-pagination?title=' + `${title}` + '&page=' + `${pageNo}` + '&size=9&sort=' + `${sortOrder}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postLoadSearchById = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postLoad/' + `${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const postNeedSearchById = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/v2/need/' + `${id}`, {
      // .get('/rfp/v2/need/6527a8448edefd4196417176', {
      headers: {
        Authorization: `${token}`,
        authId: 'authId',
        role: 'role'
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postNeedEditViewV2ById = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/v2/need/get_need_details_by_id/' + `${id}`, {
      headers: {
        Authorization: `${token}`,
        authId: 'authId',
        role: 'role'
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const commodityList = (token, newFlag, isUsedFlag, isComboFlag, isCoresFlag) => (dispatch) => {
  dispatch(showAppLoader());
  let securityKey = process.env.REACT_APP_SECRET_KEY
  if (newFlag === undefined && isUsedFlag === undefined && isComboFlag === undefined) {
    newFlag = true;
    isUsedFlag = false;
    isComboFlag = false;
    isCoresFlag = false
  }
  if (newFlag === "New") {
    newFlag = true;
  }
  if (newFlag === "Combo") {
    isComboFlag = true;
  }
  if (newFlag === "Recycled") {
    isUsedFlag = true;
  }
  if (newFlag === "Cores") {
    isCoresFlag = true;
  }
  if (isUsedFlag === undefined)
    isUsedFlag = false;

  if (isComboFlag === undefined)
    isComboFlag = false;

  if (isCoresFlag === undefined)
    isCoresFlag = false;

  return axioPath
    .get('/rfp/commodity/list?isNew=' + `${newFlag}` + '&isUsed=' + `${isUsedFlag}` + '&isCombo=' + `${isComboFlag}` + '&isCores=' + `${isCoresFlag}`, {
      headers: {
        Authorization: `${token}`,
        "Access-Control-Allow-Origin": "*",
        secretKey: securityKey,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        2000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const postLoadBidRejected = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/bid/rejected', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
// export const postLoadList = (pageNo, size, sort, status, token, searchText, fromDate, toDate, locationFlag) => (dispatch) => {
//   if(sort === true){
//     locationFlag=true
//     sort="DESC"
//   }else{
//     locationFlag=false
//   }

//   dispatch(showAppLoader());
//   if (status === undefined || status === 'All') {
//     // status = ''
//     status = 'ALL'
//   }
//   let url
//   let currentNotifiedItem = localStorage.getItem('currentNotifiedItem')
//   if (currentNotifiedItem !== undefined && currentNotifiedItem !== null && currentNotifiedItem !== '') {
//     url = `/rfp/postLoad/search-pagination-id?page=1&size=10&sort=DESC&id=${currentNotifiedItem}`
//   } else {
//     url = '/rfp/postLoad/list-pageable-innerCircle?page=' + `${pageNo}` + '&size=' + `${size}` + '&sort=' + `${sort}` + '&status=' + `${status}`
//   }
//   localStorage.removeItem('currentNotifiedItem')
//   return axioPath   
//     .get('/rfp/postLoad/list-pageable?page=' + pageNo + '&size=' + 10 + '&sort=' + `${sort}` + '&status=' + `${status}` + '&fromDate=' + fromDate + '&toDate=' + toDate + '&searchBy=' + `${searchText}`+ '&locationBy=' + `${locationFlag}`, {
//       headers: {
//         Authorization: `${token}`,
//       },
//     })
//     .then((response) => {
//       setTimeout(
//         () => {
//           dispatch(hideAppLoader());
//         },
//         3000
//       );
//       dispatch({ type: UPDATE_DATA, payload: response.data });
//       return response.data;
//     })
//     .catch((ex) => {
//       dispatch(hideAppLoader());
//       return ex;
//     });
// };
export const postLoadList = (data, token) => (dispatch) => {

  dispatch(showAppLoader());

  return axioPath
    .post('/rfp/postLoad/list-pageable', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const postLoadListV2 = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/my_posted_need', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postLoadRecurringListV2 = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/reccuring/post_needs', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// export const postLoadList = (data, token) => (dispatch) => {

//   dispatch(showAppLoader());

//   return axioPath   
//     .post('/rfp/postLoad/list-pageable',data, {
//       headers: {
//         Authorization: `${token}`,
//       },
//     })
//     .then((response) => {
//       setTimeout(
//         () => {
//           dispatch(hideAppLoader());
//         },
//         3000
//       );
//       dispatch({ type: UPDATE_DATA, payload: response.data });
//       return response.data;
//     })
//     .catch((ex) => {
//       dispatch(hideAppLoader());
//       return ex;
//     });
// };
export const findAll = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/findAll', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerPostLoadProfile = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/buyerPostLoadProfile/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const buyerPostLoadProfilePost = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/buyerPostLoadProfile/save', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const manageAccCompanyPrefUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/update/company-preferences', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const manageAccSellerBussPrefUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/user/v2/add_update_location_preference', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const locationAddress = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/location/address', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const myBidsPost = (token, data) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get(`/rfp/postLoad/bids?status=${data.bidStatus}&deliveryRequirement=${data.deliveryReq}&fromDate=${data.fromDate}&toDate=${data.toDate}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const myBidsPostV2 = (token, data) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/my_bids', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const recurrenceValidate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/recurrence/validate', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const addToFavoriteAPI = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/addToWishList', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const favoriteIconAPI = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/products/wishlist', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const getAllFavoriteAPI = (pageNo, size, sort, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/postLoad/getAllFavorite?page=' + `${pageNo}` + '&size=' + `${size}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const getAllNeedWishlist = (data, token) => (dispatch) => {
  dispatch(showAppLoader());

  return axioPath.post('/rfp/v2/products/get_all_needs_wishlist', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        5000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const recurrencePostLoadList = (locationId, authId, token, size, pageNumber, searchVal) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('rfp/schedulePostLoadIfRecurring/get/reccneed?locationId=' + `${locationId}&authId=` + `${authId}&size=` + `${size}&page=` + pageNumber + `&searchBy=${searchVal}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const deleteNeedRecurrence = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/rfp/v2/reccuring/update_recc_needs', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const postLoadDelete = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    // .get('rfp/postLoad/delete/' + `${id}`, {
    .get('rfp/v2/need/delete/' + `${id}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const postLoadUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/postLoad/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const createNeedApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const needUpdate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/v2/need/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const palletDetails = (token) => (dispatch) => {
  return axioPath.get("rfp/v2/specification/get_specification", {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const uploadSpec = (formData, token) => (dispatch) => {
  return axioPath
    .post('/rfp/uploadSpecification/uploadSpec', formData, {
      headers: {
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex
    });
};
export const uploadSpecification = (formData, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/uploadSpecification/upload', formData)
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const addSpecificationFilesDetails = (token, commodityId, gradeId, isNew, isUsed, isCombo, isCores) => (dispatch) => {
  dispatch(showAppLoader());
  let securityKey = process.env.REACT_APP_SECRET_KEY
  if (isNew === undefined && isUsed === undefined && isCombo === undefined) {
    isNew = true;
    isUsed = false;
    isCombo = false;
    isCores = false;
  }
  if (isNew === "New") {
    isNew = true;
  }
  let commodityIdVal = '';
  if (commodityId) {
    commodityIdVal = commodityId
  }
  let gradeIdVal = '';
  if (gradeId) {
    gradeIdVal = gradeId
  }
  return axioPath
    .get('/rfp/commodity/addSpecificationFilesDetails/list?isNew=' + `${isNew}` + '&isUsed=' + `${isUsed}` + '&isCombo=' + `${isCombo}` + '&gradeId=' + `${gradeIdVal}` + '&commodityId=' + `${commodityIdVal}`, {
      headers: {
        Authorization: `${token}`
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const submitQuoteApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/rfp/quote/add', data, {
      headers: {
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
